import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate
} from "react-router-dom";

import "leaflet/dist/leaflet.css";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { AuthProvider } from "./context/AuthContext";
import PrivateRoute from "./components/PrivateRoute";

import PrivacyPolicy from "./pages/PrivacyPolicy";

import LandingPage from "./pages/LandingPage";
import AuthPage from "./pages/AuthPage";
import Dashboard from "./pages/Dashboard";
import ComplaintForm from "./pages/ComplaintForm";
import RequestForm from "./pages/RequestForm";
import SuggestionForm from "./pages/SuggestionForm";
import ComplaintDetail from "./pages/ComplaintDetail";
import ComplaintChatPage from "./pages/ComplaintChatPage";
import EditProfile from "./pages/EditProfile";
import MyServiceRequests from "./pages/MyServiceRequests";
import ServiceRequestDetail from "./pages/ServiceRequestDetail";
import MySuggestions from "./pages/MySuggestions";
import SuggestionDetail from "./pages/SuggestionDetail";
function App() {
  return (
    <AuthProvider>
      <Router>

        <Routes>

          {/* Landing */}
          <Route path="/" element={<LandingPage />} />

          {/* Login / Register */}
          <Route
            path="/auth/:type"
            element={<AuthPage />}
          />


          {/* Public Privacy Policy */}
<Route
  path="/privacy-policy"
  element={<PrivacyPolicy />}
/>

          {/* Dashboard */}
          <Route
            path="/dashboard"
            element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            }
          />

          <Route
  path="/service-request/:id"
  element={
    <PrivateRoute>
      <ServiceRequestDetail />
    </PrivateRoute>
  }
/>

<Route
  path="/suggestion/:id"
  element={
    <PrivateRoute>
      <SuggestionDetail />
    </PrivateRoute>
  }
/>

<Route
  path="/my-suggestions"
  element={
    <PrivateRoute>
      <MySuggestions />
    </PrivateRoute>
  }
/>

         <Route
  path="/my-service-requests"
  element={
    <PrivateRoute>
      <MyServiceRequests />
    </PrivateRoute>
  }
/>

          {/* Edit Profile */}
          <Route
            path="/edit-profile"
            element={
              <PrivateRoute>
                <EditProfile />
              </PrivateRoute>
            }
          />

          {/* Complaint Form */}
          <Route
            path="/complaint/new"
            element={
              <PrivateRoute>
                <ComplaintForm />
              </PrivateRoute>
            }
          />

          {/* Request Form */}
          <Route
            path="/request/new"
            element={
              <PrivateRoute>
                <RequestForm />
              </PrivateRoute>
            }
          />

          {/* Suggestion Form */}
          <Route
            path="/suggestion/new"
            element={
              <PrivateRoute>
                <SuggestionForm />
              </PrivateRoute>
            }
          />

          {/* Complaint Chat */}
          <Route
            path="/complaint/:id/chat"
            element={
              <PrivateRoute>
                <ComplaintChatPage />
              </PrivateRoute>
            }
          />

          {/* Complaint Details */}
          <Route
            path="/complaint/:id"
            element={
              <PrivateRoute>
                <ComplaintDetail type="complaint" />
              </PrivateRoute>
            }
          />

          {/* Request Details */}
          <Route
            path="/request/:id"
            element={
              <PrivateRoute>
                <ComplaintDetail type="request" />
              </PrivateRoute>
            }
          />

          {/* Default */}
          <Route
            path="*"
            element={<Navigate to="/" replace />}
          />

        </Routes>

        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          closeOnClick
          pauseOnHover
        />

      </Router>
    </AuthProvider>
  );
}

export default App;